/* eslint-disable import/prefer-default-export */
import { useState, useCallback } from 'react';

export const useHeader = () => {
  /**
   * useHeader State
   */

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  /**
   * useHeader Handlers
   */

  const toggleMobileMenu = useCallback(() => setIsMobileMenuOpen(!isMobileMenuOpen), [isMobileMenuOpen]);

  /**
   * useHeader Return
   */

  return {
    isMobileMenuOpen,
    toggleMobileMenu,
  };
};
